(function () {
  function getFaqAnswer(button) {
    var item = button.closest('.aa-blog-faq__item');
    if (item) {
      return item.querySelector('.aa-blog-faq__answer');
    }

    return button.nextElementSibling;
  }

  function closeOtherFaqs(section, currentButton) {
    var buttons = section.querySelectorAll('.aa-blog-faq__question');

    buttons.forEach(function (button) {
      if (button === currentButton) return;

      button.setAttribute('aria-expanded', 'false');

      var answer = getFaqAnswer(button);
      if (answer) {
        answer.hidden = true;
      }
    });
  }

  function prepareFaqs(root) {
    var scope = root || document;
    var faqSections = scope.querySelectorAll('.aa-blog-faq');

    faqSections.forEach(function (section, sectionIndex) {
      var buttons = section.querySelectorAll('.aa-blog-faq__question');

      buttons.forEach(function (button, buttonIndex) {
        var answer = getFaqAnswer(button);
        if (!answer) return;

        if (!button.id) {
          button.id = 'aa-blog-faq-button-' + sectionIndex + '-' + buttonIndex;
        }

        if (!answer.id) {
          answer.id = 'aa-blog-faq-answer-' + sectionIndex + '-' + buttonIndex;
        }

        button.setAttribute('aria-controls', answer.id);
        answer.setAttribute('aria-labelledby', button.id);

        if (!button.hasAttribute('aria-expanded')) {
          button.setAttribute('aria-expanded', 'false');
        }

        if (button.getAttribute('aria-expanded') !== 'true') {
          answer.hidden = true;
        }
      });
    });
  }

  function toggleFaq(button) {
    var section = button.closest('.aa-blog-faq');
    if (!section) return;

    var answer = getFaqAnswer(button);
    if (!answer) return;

    var isExpanded = button.getAttribute('aria-expanded') === 'true';
    var allowMultiple = section.getAttribute('data-allow-multiple') === 'true';

    if (!allowMultiple) {
      closeOtherFaqs(section, button);
    }

    button.setAttribute('aria-expanded', String(!isExpanded));
    answer.hidden = isExpanded;
  }

  function init(root) {
    prepareFaqs(root || document);
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('.aa-blog-faq__question');
    if (!button) return;

    event.preventDefault();
    toggleFaq(button);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();